import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Snippet',
    entityNamePlural: 'Snippets',
    entityNameModule: 'cms',
  }), [])
}
